import React from 'react'
import { Avatar } from 'src/components/global/Avatar/Avatar'
import { ISolutionFounderFragment } from 'src/graphql/generated/hooks'

interface Props {
  founder: ISolutionFounderFragment
}

/**
 * Component to render founder item in ALSP/Consultancy enhanced listing page > Overview Tab.
 */
export const SolutionFounderItem: React.FC<Props> = ({ founder }) => {
  if (!founder.name && !founder.title) return null
  return (
    <div className="flex flex-row items-center mt-2">
      <div className="mr-2">
        <Avatar
          size="40px"
          initialsTextSize="12px"
          url={founder.avatar?.data?.attributes?.url}
          name={founder.name || founder.title || ''}
          defaultMode="initials"
          border="circle"
          variant="navy"
        />
      </div>
      <div>
        {founder?.externalLink ? (
          <a
            target={'_blank'}
            href={founder.externalLink || '#'}
            className="text-[0.75rem] mr-2 underline cursor-pointer underline-offset-[4px]"
            style={{ color: '#333333' }}
          >
            {[founder?.name, founder?.title]?.filter(Boolean).join(' - ')}
          </a>
        ) : (
          <div className="text-[0.75rem] mr-2 hover:no-underline" style={{ color: '#333333' }}>
            {[founder?.name, founder?.title]?.filter(Boolean).join(' - ')}
          </div>
        )}
      </div>
    </div>
  )
}
